import { PaletteOptions } from "@mui/material";
import { red } from "@mui/material/colors";
import {
  ACCENT_COLOR,
  ACCENT_DARK_COLOR,
  ACCENT_LIGHT_COLOR,
  CUSTOM_BLACK,
  ERROR_COLOR,
  ERROR_DARK_COLOR,
  ERROR_LIGHT_COLOR,
  KEYBOARD_FOCUS_OUTLINE,
  SUCCESS_COLOR,
  SUCCESS_DARK_COLOR,
  SUCCESS_LIGHT_COLOR,
  WHITE,
  grey,
} from "../colors";

type OutlineColors = {
  main: string;
};

declare module "@mui/material/styles" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Palette {
    outline: OutlineColors;
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface PaletteOptions {
    outline?: OutlineColors;
  }
}

export const paletteShared: PaletteOptions = {
  common: {
    black: CUSTOM_BLACK,
    white: WHITE,
  },
  error: {
    ...red,
    dark: ERROR_DARK_COLOR,
    light: ERROR_LIGHT_COLOR,
    main: ERROR_COLOR,
  },
  grey,
  mode: "light",
  outline: {
    main: KEYBOARD_FOCUS_OUTLINE,
  },
  secondary: {
    contrastText: WHITE,
    dark: ACCENT_DARK_COLOR,
    light: ACCENT_LIGHT_COLOR,
    main: ACCENT_COLOR,
  },
  success: {
    dark: SUCCESS_DARK_COLOR,
    light: SUCCESS_LIGHT_COLOR,
    main: SUCCESS_COLOR,
  },
} as const;
